import moment from 'moment';
import { Temporal } from 'temporal-polyfill';

// TODO: We can probably use Temporal Polyfill for this
const parseToDateObject = (value) => {
  if (!value) return new Date();

  if (value instanceof Date) {
    // FullCalendar with timeZone=false stores wall-clock time in UTC bits.
    // Re-construct as a local Date using those UTC components so the picker
    // renders the correct wall-clock time regardless of the local timezone.
    return new Date(
      value.getUTCFullYear(),
      value.getUTCMonth(),
      value.getUTCDate(),
      value.getUTCHours(),
      value.getUTCMinutes(),
      value.getUTCSeconds(),
    );
  }

  // Plain string (no Z / no offset) — parse as local to avoid shift.
  const date = moment(value, 'YYYY-MM-DDTHH:mm:ss').toDate();

  if (date.toString() === 'Invalid Date') {
    return new Date();
  }

  return date;
};

const parseToISOWithoutTimezone = (value) => {
  const date = moment(value).format('YYYY-MM-DDTHH:mm:ss');

  if (date.toString() === 'Invalid Date') {
    return moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');
  }

  return date;
};

const addDays = (value, days = 1) => moment(parseToDateObject(value)).add(days, 'days').toDate();

const addHours = (value, hours = 1) => moment(parseToDateObject(value)).add(hours, 'hours').toDate();

const getTemporalPlainDateTime = (value) => value
  .toTemporalInstant()
  .toZonedDateTimeISO('UTC')
  .toPlainDateTime()
  .toString();

const getDateOnly = (value) => {
  if (value instanceof Date) return value.toISOString().slice(0, 10);
  return String(value).slice(0, 10);
};

const calculateDurationInDays = ({ startDate, endDate }) => {
  const DEFAULT_DAYS = 7;
  if (!startDate || !endDate) return DEFAULT_DAYS;

  const start = Temporal.PlainDate.from(getDateOnly(startDate));
  const end = Temporal.PlainDate.from(getDateOnly(endDate));

  return end.since(start, { largestUnit: 'days' }).days;
};

const dateUtils = {
  addDays,
  addHours,
  calculateDurationInDays,
  getTemporalPlainDateTime,
  parseToDateObject,
  parseToISOWithoutTimezone,
};

export default dateUtils;
